import React from "react";
import { localPath } from "@Models/localPath";

interface IProps {
  path: string;
  props?: any;
  children: React.ReactNode;
  id: string;
  target?: string;
}

const LinkButton = ({ props, path, children, id, target = "" }: IProps) => {
  // v2 es un monolito: todas las rutas viven en el mismo origen (antes caía a
  // http://localhost:9000, el v1, en cualquier host sin "qa"/"app").
  const baseUrl = localPath;

  return (
    <a href={`${baseUrl}${path}`} id={id} {...props} target={target}>
      {children}
    </a>
  );
};

export default LinkButton;
